@if (label && usesFloatLabel()) {
  <p-floatLabel>
    <ng-template [ngTemplateOutlet]="dropdown"></ng-template>
    <label [for]="inputId">{{ label }}</label>
  </p-floatLabel>
} @else {
  <ng-template [ngTemplateOutlet]="dropdown"></ng-template>
}

<ng-template #dropdown>
  <p-treeSelect
    #treeSelect
    [options]="_options | orderBy: 'data.' + sort"
    [(ngModel)]="selectionMode === 'single' ? _selectedItem : _selectedItems"
    (ngModelChange)="onChangeValue($event)"
    (onHide)="onPanelHide()"
    (onShow)="onPanelShow()"
    (onFilter)="filterValue($event)"
    (onNodeSelect)="onNodeSelect($event)"
    (onNodeUnselect)="onNodeUnselect($event)"
    [placeholder]="inputPlaceholder()"
    [inputId]="inputId"
    [selectionMode]="selectionMode"
    [filter]="filter"
    [filterBy]="filterBy"
    class="w-full {{ class }}"
    [panelStyleClass]="mergedPanelStyleClass"
    [disabled]="disabled"
    [appendTo]="appendTo"
    [emptyMessage]="emptyMessage"
    [scrollHeight]="scrollHeight"
    [metaKeySelection]="metaKeySelection"
    [filterInputAutoFocus]="filterInputAutoFocus"
    [panelStyle]="panelStyle"
    [showClear]="showClear"
    [display]="treeSelectDisplay"
    [loading]="loading">
    <ng-template
      let-node
      pTemplate="default">
      @if (node) {
        <div class="color-black {{ itemStyleClass }}">
          <span [innerHTML]="highlightMatchText(node.label) | safeHtml"></span>
        </div>
      }
    </ng-template>

    @if (valueTemplate) {
      <ng-template
        let-node
        let-placeholder="placeholder"
        pTemplate="value">
        @if (selectionMode === 'single') {
          @if (_selectedItem) {
            <ng-template
              [ngTemplateOutlet]="valueTemplate"
              [ngTemplateOutletContext]="{ node: node, placeholder: placeholder }"></ng-template>
          } @else {
            @if (!usesFloatLabel() || !label) {
              {{ placeholder }}
            }
          }
        } @else {
          @if (_selectedItems?.length) {
            <ng-template
              [ngTemplateOutlet]="valueTemplate"
              [ngTemplateOutletContext]="{
                selectedItems: _selectedItems,
                placeholder: placeholder,
                removeSelectedItem: removeSelectedItem
              }"></ng-template>
          } @else {
            @if (!usesFloatLabel() || !label) {
              {{ placeholder }}
            }
          }
        }
      </ng-template>
    } @else if (display === 'chip' && selectionMode !== 'single') {
      <ng-template
        pTemplate="value"
        let-selectedNodes
        let-placeholder="placeholder">
        @if (selectedNodes?.length) {
          @if (selectedNodes.length > effectiveMaxSelectedLabels) {
            {{ formatSelectedItemsLabel(selectedNodes.length) }}
          } @else {
            @for (node of selectedNodes; track node.key) {
              <div class="p-treeselect-token">
                <span class="p-treeselect-token-label">{{ node.label }}</span>
                @if (!disabled) {
                  <span
                    class="p-treeselect-token-icon pi pi-times-circle"
                    tabindex="0"
                    role="button"
                    [attr.aria-label]="'Удалить'"
                    (click)="removeSelectedItem(node, $event)"
                    (keydown.enter)="removeSelectedItem(node, $event)"></span>
                }
              </div>
            }
          }
        } @else {
          @if (!usesFloatLabel() || !label) {
            {{ placeholder }}
          }
        }
      </ng-template>
    }
  </p-treeSelect>
</ng-template>
